import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from './header';
import { revenueInsights_template } from '../components/templates/revenueInsights_template';
import { getRequestErrorMessage } from '~/utils/requestError';
export class revenueInsights extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.listRequestGeneration = 0;
    }
    getModuleName() {
        return 'revenue_insights';
    }
    cleanup() {
        this.tpl?.destroyDatePickerCalendar?.();
        this.tpl?.destroyLastRefreshedClock?.();
        this.tpl?.destroySummaryCharts?.();
    }
    internalLoad(container) {
        this.build();
        this.insertIn(container);
        for (const element of this.content) {
            try {
                ko.applyBindings(this.viewModel, element);
            }
            catch (error) {
                console.error('Knockout binding failed for', element.id, error);
            }
        }
        this.loadSavedViewModule();
        try {
            this.fillPage();
        }
        finally {
            container.classList.remove('loading');
        }
    }
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader?.loadedModule;
        loadedModule?.setHeaderTitle('Revenue Insights');
        loadedModule?.setBreadcrumbs([
            { label: 'Home', href: '/home', icon: 'home' },
            { label: 'Revenue Insights', href: null },
        ]);
        this.tpl = new revenueInsights_template('revenueInsights_template', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    fillPage() {
        try {
            this.tpl.buildDatePickerCalendar();
            this.getListFormData();
        }
        catch (error) {
            console.error(error);
            this.failListLoading('Unable to initialize revenue insights.');
        }
    }
    startListLoading() {
        this.tpl?.activateLoading();
    }
    completeListLoading() {
        this.tpl?.completeLoading();
    }
    failListLoading(message) {
        this.tpl?.failLoading(message);
    }
    getListFormData() {
        this.startListLoading();
        this.requestHandler = new XMLHttpRequestHandler('/api/revenueInsights/references/', [], this);
        this.requestHandler.onReadyStateFunction = this.onFilterRequestReturn;
        this.requestHandler.execute();
    }
    onFilterRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            if (req.request.status !== 200) {
                try {
                    obj.manageResponse(req, obj, undefined);
                }
                catch (error) {
                    console.error(error);
                }
                obj.failListLoading(getRequestErrorMessage(req.request, 'Unable to load revenue insight filters.'));
                return;
            }
            try {
                obj.manageResponse(req, obj, function () {
                    const responseParsed = JSON.parse(req.request.response || '{}');
                    obj.updateFilters(responseParsed);
                    obj.updateViewModelFromPath();
                    obj.getListData();
                });
            }
            catch (error) {
                console.error(error);
                obj.failListLoading('Revenue insight filters returned an invalid response.');
            }
        };
    }
    updateFilters(responseParsed) {
        this.tpl.setBrandFilterItems(responseParsed?.brands);
        this.tpl.setProductFilterItems(responseParsed?.products);
        this.tpl.setPartnerFilterItems(responseParsed?.partners);
        this.tpl.setBuyerFilterItems(responseParsed?.buyers);
        this.tpl.setTrafficFilterItems(responseParsed?.trafficSources);
        this.tpl.setChannelFilterItems(responseParsed?.channels);
        this.tpl.setDeviceFilterItems(responseParsed?.devices);
        this.tpl.setLeadTypeFilterItems(responseParsed?.leadTypes);
        this.tpl.setFormVariantFilterItems(responseParsed?.formVariants);
        this.tpl.setAudienceFilterItems(responseParsed?.audiences);
        this.tpl.setClickAuctionExperimentFilterItems(responseParsed?.clickAuctionExperiments);
        this.tpl.setLeadAuctionExperimentFilterItems(responseParsed?.leadAuctionExperiments);
    }
    getListData() {
        const generation = ++this.listRequestGeneration;
        this.startListLoading();
        try {
            const subViewModel = this.tpl.getViewModelForRequest();
            const baseApiUrl = '/api/revenueInsights/get/';
            this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn(generation), XMLHttpRequestHandler_requestType.GET, 'getListData');
        }
        catch (error) {
            console.error(error);
            this.failListLoading('Unable to request revenue insights.');
        }
    }
    onDataRequestReturn(generation) {
        return (req, obj) => {
            return function () {
                if (req.request.readyState !== 4) {
                    return;
                }
                if (generation !== obj.listRequestGeneration) {
                    return;
                }
                if (req.request.status !== 200) {
                    try {
                        obj.manageResponse(req, obj, undefined);
                    }
                    catch (error) {
                        console.error(error);
                    }
                    obj.failListLoading(getRequestErrorMessage(req.request, 'Unable to refresh revenue insights.'));
                    return;
                }
                try {
                    obj.manageResponse(req, obj, function () {
                        const responseParsed = JSON.parse(req.request.response || '{}');
                        obj.updateList(responseParsed);
                        if (responseParsed?.filters) {
                            obj.tpl.setPartnerFilterItems(responseParsed.filters.partners);
                            obj.tpl.setBuyerFilterItems(responseParsed.filters.buyers);
                        }
                    });
                    obj.completeListLoading();
                }
                catch (error) {
                    console.error(error);
                    obj.failListLoading('Revenue insights returned an invalid response.');
                }
            };
        };
    }
    updateList(responseParsed) {
        const lastRefreshedAt = responseParsed?.lastRefreshedAt
            ?? responseParsed?.status?.maxDateCreated
            ?? null;
        this.tpl.setStatus(responseParsed?.status);
        this.tpl.setTotalsData(responseParsed?.totalsData ?? []);
        this.tpl.setListData(responseParsed?.listData ?? []);
        this.tpl.setLastRefreshedAt(lastRefreshedAt);
    }
    filterDropdownOnChange() {
        this.tpl.applyLeadTypeColumnVisibility();
        this.getListData();
    }
    filterMultipleSelectorOnChange(_elem) {
        this.tpl.applyLeadTypeColumnVisibility();
        this.getListData();
    }
    filterDateOnChange() {
        this.tpl.applyLeadTypeColumnVisibility();
        this.getListData();
    }
    getExportData() {
        this.tpl.setExporting(true);
        try {
            const subViewModel = this.tpl.getViewModelForRequest();
            const parameters = [["data", ko.toJSON(subViewModel)]];
            this.requestHandler = new XMLHttpRequestHandler('/api/revenueInsights/export/', parameters, this);
            this.requestHandler.onReadyStateFunction = this.onExportDataReturn;
            this.requestHandler.execute();
        }
        catch (error) {
            console.error(error);
            this.tpl.setExporting(false);
        }
    }
    onExportDataReturn(req, obj) {
        return function () {
            const xhr = req.request;
            if (xhr.readyState !== 4) {
                return;
            }
            try {
                if (xhr.status !== 200) {
                    const res = JSON.parse(xhr.responseText || "{}");
                    if (res.error) {
                        alert(res.error);
                    }
                    return;
                }
                const csv = xhr.responseText;
                const disposition = xhr.getResponseHeader("Content-Disposition");
                let filename = "revenueInsights-export.csv";
                if (disposition) {
                    const match = /filename="?([^";\n]+)"?/.exec(disposition);
                    if (match) {
                        filename = match[1].trim();
                    }
                }
                const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                obj.tpl.setExporting(false);
            }
        };
    }
}
